import type { RoutableScreenId } from './contract'

const STORAGE_KEY = 'dimeroot.auth.destination'
export type SignInDestination = Extract<RoutableScreenId, 'dashboard' | 'upload'>

export function requestedSignInDestination(query: URLSearchParams): SignInDestination {
  return query.get('next') === 'upload' ? 'upload' : 'dashboard'
}

/** Persists only a screen id across the top-level provider redirect. */
export function rememberSignInDestination(destination: SignInDestination): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, destination)
  } catch {
    // Private browsing can deny storage; dashboard is the safe returning-user path.
  }
}

/** Read-once so an abandoned first-run attempt cannot affect a later sign-in. */
export function takeSignInDestination(): SignInDestination {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_KEY)
    return stored === 'upload' ? 'upload' : 'dashboard'
  } catch {
    return 'dashboard'
  }
}
